import { render, staticRenderFns } from "./OrderShippingNotificationFlow.vue?vue&type=template&id=67a1be0f&scoped=true&"
import script from "./OrderShippingNotificationFlow.vue?vue&type=script&lang=js&"
export * from "./OrderShippingNotificationFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1be0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a1be0f')) {
      api.createRecord('67a1be0f', component.options)
    } else {
      api.reload('67a1be0f', component.options)
    }
    module.hot.accept("./OrderShippingNotificationFlow.vue?vue&type=template&id=67a1be0f&scoped=true&", function () {
      api.rerender('67a1be0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/OrderShippingNotification/OrderShippingNotificationFlow.vue"
export default component.exports